module.exports = "/_next/static/images/CollectionSourceFunctions-971ac62d562b050422c90b01aed196ea.webp";